import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '10px',
    padding: '10px',
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: '1px solid #e0e0e0',
    borderRadius: '5px',
    margin: '10px 0px',
  },
  icon: {
    width: '20px',
    height: '20px',
    '& path': {
      fill: theme.palette.text.primary,
    }
  },
  text: {
    flex: 1,
    fontWeight: 500,
    overflowY: 'auto',
    maxHeight: '70px',
    overflowX: 'hidden',
    wordWrap: 'break-word',
  },
  responseTime: {
    fontWeight: 700,
    color: '#4caf50',
  },
}));

export default useStyles;
